"use strict";
/*
 * Created on 01 15 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link ValidationResultObject validation result object} entity.
 *
 * @author JMe
 */


var ValidationResultObjectConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ValidationResultObjectConverter, _DataObjectConverter_);

  function ValidationResultObjectConverter() {
    _classCallCheck(this, ValidationResultObjectConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationResultObjectConverter).apply(this, arguments));
  }

  return ValidationResultObjectConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ValidationResultObjectConverter = ValidationResultObjectConverter;